<template>
  <div class="contactusPc">
    <div class="banner">
      <img src="https://cdn.youjiajk.com/yjExperienceBanner1.png" style="width: 100%;" />
    </div>
    <div class="tab">
      <div class="content">
        <div class="tabTitle">
          <span :class="currentIndex == 1 ? 'active' : ''" @click="currentChange(1)">家庭医生</span>
          <span :class="currentIndex == 2 ? 'active' : ''" @click="currentChange(2)">就医陪诊</span>
          <!-- <span :class="currentIndex == 3 ? 'active activeStyle' : ''" @click="currentChange(3)">门诊险</span> -->
        </div>
        <div class="tabCon content">
          <div v-if="currentIndex == 1" :class="['m-video', { hover: !originPlay }]"
            :style="`width: ${width}px; height: ${height}px;`">
            <video ref="veo" :class="{ cursor: !originPlay }" :style="`object-fit: ${zoom};`" :src="videoUrl1"
              :width="width" :height="height" :autoplay="autoplay" :controls="!originPlay&&controls" :loop="loop"
              :muted="autoplay || muted" :preload="preload">
              您的浏览器不支持video标签。
            </video>
            <svg :class="[vplay ? 'play cursor':'hidden']" :style="`width: ${playWidth}px; height: ${playWidth}px;`" @click="clickPlay" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.75 6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H17.25C18.3546 4.75 19.25 5.64543 19.25 6.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V6.75Z"></path>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.25 12L9.75 8.75V15.25L15.25 12Z"></path>
            </svg>
          </div>
          <div v-if="currentIndex == 2" :class="['m-video', { hover: !originPlay }]"
            :style="`width: ${width}px; height: ${height}px;`">
            <video ref="veo" :class="{ cursor: !originPlay }" :style="`object-fit: ${zoom};`" :src="videoUrl3"
              :width="width" :height="height" :autoplay="autoplay" :controls="!originPlay&&controls" :loop="loop"
              :muted="autoplay || muted" :preload="preload">
              您的浏览器不支持video标签。
            </video>
            <svg :class="[vplay ? 'play cursor':'hidden']" :style="`width: ${playWidth}px; height: ${playWidth}px;`" @click="clickPlay" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.75 6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H17.25C18.3546 4.75 19.25 5.64543 19.25 6.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V6.75Z"></path>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.25 12L9.75 8.75V15.25L15.25 12Z"></path>
            </svg>
          </div>
          <div v-if="currentIndex == 3" :class="['m-video', { hover: !originPlay }]"
            :style="`width: ${width}px; height: ${height}px;`">
            <video ref="veo" :class="{ cursor: !originPlay }" :style="`object-fit: ${zoom};`" :src="videoUrl2"
              :width="width" :height="height" :autoplay="autoplay" :controls="!originPlay&&controls" :loop="loop"
              :muted="autoplay || muted" :preload="preload">
              您的浏览器不支持video标签。
            </video>
            <svg :class="[vplay ? 'play cursor':'hidden']" :style="`width: ${playWidth}px; height: ${playWidth}px;`" @click="clickPlay" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.75 6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H17.25C18.3546 4.75 19.25 5.64543 19.25 6.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V6.75Z"></path>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.25 12L9.75 8.75V15.25L15.25 12Z"></path>
            </svg>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        currentIndex: 1,
        videoUrl1: 'https://cdn.youjiajk.com/家庭医生.m4v',
        videoUrl2: 'https://cdn.youjiajk.com/门诊险.mp4',
        videoUrl3: 'https://cdn.youjiajk.com/就医陪诊.m4v',
        autoplay: false,
        controls: true,
        loop: false,
        muted: false,
        preload: 'auto',
        playWidth: 96,
        zoom: 'fill',
        width: 1200,
        height: 675,
        originPlay: true,
        vplay: true

      }
    },
    methods: {
      currentChange(index) {
        this.currentIndex = index
      },
      clickPlay() {
        this.$refs.veo.play()
        this.vplay = false
        if (this.originPlay) {
          this.originPlay = false
        }
      }

    }
  }
</script>

<style lang="less" scoped>
  .backgroundGray {
    background: #F8F9FD;
  }

  .content {
    width: 1200px;
    margin: 0 auto;
  }

  .title {
    font-size: 40px;
    color: #333333;
    font-family: Source Han Sans CN, Source Han Sans CN-6;
    font-weight: 500;
    text-align: center;
  }

  .contactusPc {
    font-size: 12px;
    display: flex;
    flex-direction: column;

    .banner {
      width: 100%;

      .bannerH2 {
        margin-top: 185px;
        font-size: 60px;
        font-family: Source Han Sans CN, Source Han Sans CN-5;
        font-weight: 400;
        line-height: 70px;
        margin-bottom: 85px;
      }

      .bannerP {
        font-size: 18px;
        line-height: 28px;
        color: #666666;
        width: 564px;
      }

      .bannerImg {
        width: 140px;
        height: 140px;
        margin-top: 30px;
      }
    }

    .tab {
      padding: 140px 0 128px;
      background: #FFFFFF;

      .tabTitle {
        border-bottom: 1px solid #e9ebed;
        font-size: 18px;
        font-family: Source Han Sans CN, Source Han Sans CN-6;
        font-weight: 500;
        padding-bottom: 20px;
        text-align: center;

        span {
          cursor: pointer;

          &:not(:last-child) {
            margin-right: 210px;
          }

        }

        .active {
          position: relative;

          &::after {
            content: '';
            position: absolute;
            bottom: -23px;
            left: 7px;
            border-bottom: 3px solid #fd8246;
            width: 56px;
          }
        }

        .activeStyle {
          &::after {
            content: '';
            position: absolute;
            bottom: -23px;
            left: 4px;
            border-bottom: 3px solid #fd8246;
            width: 47px;
          }
        }
      }

      .tabCon {
        width: 1200px;
        text-align: center;
        margin-top: 26px;
      }

      .cursor {
        width: 100%;
      }
    }

    .m-video {
      display: inline-block;
      position: relative;
      background: #000;

      .cursor {
        cursor: pointer;
      }

      .play {
        fill: none;
        color: #FFF;
        opacity: 0.7;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        transition: opacity .3s;

        &:hover {
          opacity: 0.9;
        }
      }

      .hidden {
        display: none;
      }
    }

    .hover {
      &:hover {
        .play {
          opacity: 0.9;
        }
      }
    }

  }
</style>


// WEBPACK FOOTER //
// src/views/pc/YJExperiencePc.vue